<template>
  <div class="parc-list">
    <h1 class="mb-5">
      <span v-if="!isSelectedProfil">
        Bienvenue sur OREOL
      </span>
      <span v-else-if="!isAdministrateurPortail">
        Vos parcs en gestion
      </span>
      <span v-else>
        Liste des parcs éoliens
      </span>
    </h1>

    <!-- Alertes -->
    <b-alert :model-value="true" class="rounded" variant="info" show v-if="!isSelectedProfil">
      <b-spinner small label="Small Spinner"></b-spinner>
      <span class="ms-2">
        Chargement des profils utilisateurs...
      </span>
    </b-alert>
    <b-alert :model-value="true" class="rounded" variant="info" show v-else-if="loading">
      <b-spinner small label="Small Spinner"></b-spinner>
      <span class="ms-2">
        Chargement...
      </span>
    </b-alert>
    <div
      class="alert alert-warning rounded"
      role="alert"
      v-else-if="
        !isParcs && !isEmptySearch && !loading && !isAdministrateurPortail
      "
    >
      Aucun parc n'est associé à votre profil
    </div>

    <div v-else-if="!loading">
      <!-- Recherche -->

      <!-- Btn download csv parc exploitant -->
      <div class="d-flex justify-content-end mb-2" v-if="isExploitant">
        <p-button round type="info" :disabled="isDownloading" @click="downloadExploitantParcsFile">
          <b-spinner small class="me-2" v-if="isDownloading" />
          <i class="fa fa-download me-1" v-else></i>
          {{ downloadLabel }}
        </p-button>
      </div>

      <SearchCard
        @search-parcs="getParcsByProfile"
      />

      <!-- Liste des parcs -->
      <div class="row d-flex flex-wrap">
        <div
          class="col-12 col-md-4 parc-card-container"
          v-for="parc in parcs"
          :key="parc.id"
        >
          <!-- Carte Parc -->
          <parc-card>
            <template #title>
              <p class="mb-1 parc-name">{{ parc.nomUsuel }}</p>
              <p class="mb-2">{{ parc.id }}</p>
            </template>

            <template #header>
              <div class="icon-big text-center parc-icon" :class="`icon-${getClasseStatut(parc)}`">
                <i class="ti-map-alt"></i>
              </div>
            </template>

            <template #content>
              <div class="numbers d-flex flex-column justify-content-between">
                <div class="parc-status-list">
                  <p class="parc-admin-status">
                    {{ parc.statutAdministratif.description }}
                  </p>
                  <p>
                    {{ parc.statutParc.libelle }}
                  </p>
                  <p class="parc-etat">
                  <span v-if="parc.etatParc.libelle">
                    {{ parc.etatParc.libelle }}
                  </span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>

                <div
                  class="parc-localisation mt-3"
                  v-if="parc.regions.length > 0"
                >
                  <p>
                  <span v-for="(region, index) in parc.regions" :key="index">
                    <span v-if="index > 0"> - </span>{{ $filters.formatRegion(region) }}</span
                  >
                  </p>
                  <p>
                  <span
                    v-for="(departement, index) in parc.departements"
                    :key="index"
                  >
                    <span v-if="index > 0"> - </span>{{ $filters.formatDepartement(departement) }}</span
                  >
                  </p>
                </div>
                <div
                  class="parc-localisation parc-localisation--empty text-muted"
                  v-else
                >
                  <p><small>Localisation non renseignée</small></p>
                </div>
              </div>
            </template>

            <template #footer>
              <div class="stats d-flex justify-content-between mb-1">
                <div>
                  <span
                    :class="'alert alert-' + getStatutSaisieColor(parc.statutSaisie.libelle)"
                    role="alert"
                    v-if="parc.statutSaisie.libelle"
                  >
                    {{ parc.statutSaisie.description }}
                  </span>
                  <span class="alert alert-dark" role="alert" v-else>Données non-publiées</span>
                </div>
                <router-link :to="{ path: '/parc-profile', query: { parcId: parc.id } }">
                  <div>
                    <p-button
                      type="info"
                      outline
                      icon
                      id="parc-profile"
                      title="Afficher le parc"
                    >
                      <i class="fa fa-search"></i>
                      <b-tooltip target="#parc-profile">
                        Afficher le parc
                      </b-tooltip>
                    </p-button>
                  </div>
                </router-link>
              </div>
            </template>
          </parc-card>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12 text-center" v-if="isMoreResultsButtonVisible">
          <button type="button" class="btn btn-info" @click="showMoreResults">
            Plus de résultats
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {ParcListParcCard, ParcListSearchCard} from "@/components/index";
import {parcService} from "@/service/parc.service.js";
import {collectiviteService} from "@/service/collectivite.service.js";
import {BAlert, BSpinner, BTooltip} from "bootstrap-vue-next";

import {mapGetters} from "vuex";

export default {
  components: {
    BTooltip,
    ParcCard: ParcListParcCard,
    SearchCard: ParcListSearchCard,
    BAlert,
    BSpinner
  },
  data() {
    return {
      page: {
        size: Number(this.$route.query.size),
        totalElements: "",
        step: 10
      },
      loading: true,
      isDownloading: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      selectedDroit: "selectedDroit",
      isSelectedProfil: "isSelectedProfil",
      isExploitant: "isExploitant",
      isGestionnaire: "isGestionnaire",
      isDreal: "isDreal",
      isAdministrateur: "isAdministrateur",
      isAdministrateurPortail: "isAdministrateurPortail",
      parcs: "parcs",
      isParcs: "isParcs",
      isEmptySearch: "isEmptySearch",
      hasSearched: "hasSearched",
      regions: "regions",
      departements: "departements",
      nomRegionListByInseeRegionList: "nomRegionListByInseeRegionList",
      nomDepartementListByInseeDepartementList:
        "nomDepartementListByInseeDepartementList",
      isCollectivites: "isCollectivites",
      searchParams: "searchParams"
    }),
    pageSizeQueryParam() {
      return Number(this.$route.query.size);
    },
    paginationRouterLink() {
      return {
        name: "parc-list",
        query: { size: this.pageSizeQueryParam }
      };
    },
    isMoreResultsButtonVisible() {
      return (
        this.page.totalElements > 10 &&
        this.pageSizeQueryParam < this.page.totalElements
      );
    },
    downloadLabel() {
      return this.isDownloading
        ? "Téléchargement..."
        : "Exporter tous mes parcs";
    }
  },
  watch: {
    paginationRouterLink() {
      if (this.isSelectedProfil) {
        this.getParcsByProfile();
      }
    }
  },
  created() {
    if (!this.isSelectedProfil) {
      this.$router.push({ name: "profile-choice" });
    } else {
      this.init();
    }
  },
  methods: {
    init() {
      if (!this.isCollectivites) {
        Promise.all([this.getRegions(), this.getDepartements()]).then(() => {
          this.getParcsByProfile();
        });
      } else {
        this.getParcsByProfile();
      }
    },
    downloadExploitantParcsFile() {
      this.isDownloading = true
      return parcService
        .fetchExploitantParcsDownloadFile().then(() => this.isDownloading = false)

    },
    getRegions() {
      return new Promise((resolve, reject) => {
        collectiviteService
          .getRegions()
          .then(data => {
            this.$store.dispatch("saveRegions", data);
          })
          .then(() => {
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject();
          });
      });
    },
    getDepartements() {
      return new Promise((resolve, reject) => {
        collectiviteService
          .getDepartements()
          .then(data => {
            this.$store.dispatch("saveDepartements", data);
          })
          .then(() => {
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    getParcsByProfile() {
      this.$store.dispatch("saveParcs", []);
      this.page.totalElements = 0;
      this.loading = true;
      if (this.selectedDroit) {
        if (this.isAdministrateurPortail) {
          this.getParcs();
        } else if (this.isAdministrateur) {
          this.getParcsByRegion();
        } else if (this.isGestionnaire) {
          this.getEquipeDrealParcs(this.selectedDroit.code_entite);
        } else if (this.isExploitant) {
          this.getAllExploitantParcs();
        }
      }
    },
    getParcs() {
      if (this.hasSearched) {
        parcService
          .getParcs(this.pageSizeQueryParam, this.searchParams, null)
          .then(data => this.handleParcsResponse(data))
          .catch(err => console.log(err));
      } else {
        this.loading = false;
      }
    },
    getParcsByRegion() {
      const regionInsee = !this.hasSearched ? this.selectedDroit.region : null;
      parcService
        .getParcs(this.pageSizeQueryParam, this.searchParams, regionInsee)
        .then(data => this.handleParcsResponse(data))
        .catch(err => console.log(err));
    },
    getParc(parcId) {
      parcService
        .getParcById(parcId, this.pageSizeQueryParam)
        .then(data => {
          if (data) {
            const parc = this.parcMapper(data);
            this.parcs.push(parc);
            this.parcs.sort((a, b) => {
              return a.statutParc.id > b.statutParc.id ? 1 : -1;
            });

            this.page.totalElements = data.totalElements;
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEquipeDrealParcs(service) {
      parcService
        .getEquipeDrealParcs(
          service,
          this.pageSizeQueryParam,
          this.searchParams
        )
        .then(data => this.handleParcsResponse(data))
        .catch(err => console.log(err));
    },
    getAllExploitantParcs() {
      parcService
        .getAllExploitantParcs(this.pageSizeQueryParam, this.searchParams)
        .then((data) => this.handleParcsResponse(data))
        .catch(err => console.log(err));
    },
    parcMapper(parc) {
      const collectivites = this.collectivitesMapper(parc);
      return {
        id: parc.id ? parc.id : `Parc n°${index} à remplir`,
        nomUsuel: parc.nomUsuel ? parc.nomUsuel : "Nom N/A",
        statutAdministratif: parc.statutAdministratif
          ? parc.statutAdministratif
          : { libelle: "", description: "" },
        statutParc: parc.statutParc
          ? parc.statutParc
          : { libelle: "", description: "" },
        etatParc: parc.etatParc
          ? parc.etatParc
          : { libelle: "", description: "" },
        regions: collectivites.regions.length > 0 ? collectivites.regions : [],
        departements:
          collectivites.departements.length > 0
            ? collectivites.departements
            : [],
        statutSaisie: parc.statutSaisie
          ? parc.statutSaisie
          : { libelle: "", description: "" }
      };
    },
    collectivitesMapper(parc) {
      const codeRegion = new Set();
      const codeDepartement = new Set();
      const collectivites = {
        regions: [],
        departements: []
      };
      if (parc.inventaireCommunes && parc.inventaireCommunes.length > 0) {
        parc.inventaireCommunes.forEach(inventaire => {
          codeRegion.add(inventaire.codeRegion);
          codeDepartement.add(inventaire.codeDepartement);
        });

        collectivites.regions = this.nomRegionListByInseeRegionList([
          ...codeRegion
        ]);

        collectivites.departements = this.nomDepartementListByInseeDepartementList(
          [...codeDepartement]
        );
      }
      return collectivites;
    },
    showMoreResults() {
      this.page.size = Number(this.pageSizeQueryParam) + Number(this.page.step);
      const query = { size: this.page.size };
      this.$router.push({ name: "parc-list", query: { size: this.page.size } });
    },
    getStatutSaisieColor(statutSaisieLibelle) {
      switch (statutSaisieLibelle) {
        case "Brouillon":
          return "warning";
        case "Publié":
          return "success";
        case "Dépublié":
          return "danger";
        case "Saisie non démarrée":
          return "secondary";
        default:
          return "";
      }
    },
    handleParcsResponse(data) {
      if (data?.content) {
        const parcs = [];

        data.content.forEach((parc) => parcs.push(this.parcMapper(parc)));
        parcs.sort((a, b) => a.statutParc.id > b.statutParc.id ? 1 : -1);

        this.$store.dispatch("saveParcs", parcs);
        this.page.totalElements = data.totalElements;
      }
      this.loading = false;
    }
  }
};
</script>
<style lang="scss">
.parc-list {
  .parc-card-container {
    min-width: 401px;

    .numbers {
      height: 100%;
    }

    .parc-etat span {
      font-size: 0.9em;
    }
    .parc-admin-status {
      //text-transform: uppercase;
      font-weight: normal;
    }

    .parc-name {
      font-size: 1.3em;
      color: #403d39;
      + p {
        font-size: 1em;
      }
    }

    .parc-status-list > * {
      font-size: 0.6em;
    }

    .parc-localisation {
      & > * {
        font-size: 0.5em;
        font-style: italic;
      }

      &--empty {
        margin-top: 34px;
      }
    }

    span {
      &.alert {
        display: inline-block;
        margin: 0;
        &-dark {
          color: #252422;
        }
      }
    }
  }
}
</style>
